const diningChoiceEnum = Object.freeze({
  DINE_IN: 'dine-in',
  TAKE_AWAY: 'take-away',
  DELIVERY: 'delivery',
});

export default diningChoiceEnum;
